// extracted by css-extract-rspack-plugin
export default {"MPCard":"MPCard-AXHY25","mpCard":"MPCard-AXHY25","BoxShadowLight":"BoxShadowLight-Dj4Nkh","boxShadowLight":"BoxShadowLight-Dj4Nkh"};